<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" />

    <Flex
      justify-start
      items-center
      gap-2
      @click="update"
      class="text-sm"
      :class="[noPadding ? 'px-0' : 'px-2', { 'h-[24px]': dense, 'h-[40px]': !dense }]"
    >
      <Flex
        center
        class="size-6 rounded border hover:border-primary-500"
        :class="computedStatus"
      >
        <transition name="pop">
          <IconSolid
            icon="fa-check"
            v-if="inputValue || checked"
            class="text-gray-50"
          />
        </transition>
      </Flex>
      <span v-if="status" class="select-none"> {{ status }} </span>
    </Flex>
    <Error :message="error" />
  </FlexCol>
  <!-- {{ props }} -->
</template>

<script setup>
import { ref, watch, computed } from "vue";

const props = defineProps({
  disabled: { type: Boolean, default: false },
  error: Array,
  label: String,
  status: String,
  required: Boolean,
  modelValue: Boolean,
  dense: Boolean,
  checked: Boolean,
  disableAction: Boolean,
  noPadding: Boolean,
});

const error = ref(props.error);
const emit = defineEmits(["update:modelValue"]);

// 🔹 Inicializa respeitando modelValue ou checked
const inputValue = ref(props.modelValue ?? props.checked ?? false);

const computedStatus = computed(() => {
  return [
    props.error ? "border border-red-600" : "",
    inputValue.value || props.checked
      ? "bg-primary-500 text-white"
      : "bg-gray-50",
  ];
});

const update = () => {
  if (!props.disabled && !props.disableAction) {
    inputValue.value = !inputValue.value;
    emit("update:modelValue", inputValue.value);
  }
};

// 🔹 Sincroniza quando modelValue mudar
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== inputValue.value) {
      inputValue.value = newValue;
    }
  },
  { immediate: true },
);

// 🔹 Sincroniza quando checked mudar
// watch(
//   () => props.checked,
//   (newValue) => {
//     if (newValue !== inputValue.value) {
//       inputValue.value = newValue;
//     }
//   },
//   { immediate: true },
// );

// 🔹 Sincroniza erro
watch(
  () => props.error,
  (newValue) => {
    error.value = newValue;
  },
);
</script>

<style>
.pop-enter-active,
.pop-leave-active {
  animation: pop-in 0.1s ease-out;
}

.pop-leave-active {
  animation: pop-out 0.1s ease-in;
}

@keyframes pop-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes pop-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
</style>
